
interface AppTitleProps {
  className?: string;
}

export default function AppTitle({ className = "text-2xl font-bold" }: AppTitleProps) {
  return (
    <h1 className={className}>
      App Bônus - prof. Vinicius
    </h1>
  );
}
